import { User } from "../../../models";
import Avatar from "./Avatar";
import Link from "next/link";
import ProBadgeSvg from "../../svgs/ProBadgeSvg";

export interface UserLoggedInProps {
  user: User;
}

const UserLoggedIn: React.FC<UserLoggedInProps> = ({ user }) => {
  return (
    <Link href="/perfil">
      <a>
        <div className="flex flex-row space-x-4">
          <Avatar user={user} width={48} height={48} />
          <div className="flex flex-col items-start">
            <div className="font-semibold flex-row flex items-center">
              <span className="mr-1">{user.first}</span>
              {user.membership?.type === "paid" && (
                <ProBadgeSvg className="w-6 h-4" />
              )}
            </div>
            <div className="text-sm text-gray-text">@{user.username}</div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default UserLoggedIn;
